// Core Imports
import { queryClient } from '@/core/lib/query-client'
import { useThemeStore } from '@/core/stores/theme.store'

// Module Imports
import type { TSignInResponse, TUser } from '@/modules/auth/auth.types'
import type { TPermissionKey } from '@/modules/role/role.types'
import { authUserQueryOptions } from '@/modules/auth/auth.hooks'

export const getAuth = async (): Promise<TUser | null> => {
  try {
    const queryKey = ['authUser']
    let auth = queryClient.getQueryData<TUser>(queryKey)
    const authQueryState = queryClient.getQueryState<TUser>(queryKey)

    if (!auth || authQueryState?.isInvalidated) {
      auth = await queryClient.fetchQuery(authUserQueryOptions())
    }

    return auth ?? null
  } catch {
    return null
  }
}

export const signIn = (data: TSignInResponse) => {
  queryClient.setQueryData(['authUser'], data)
  queryClient.setQueryData(['accessToken'], data.access_token)
}

export const signOut = async () => {
  await queryClient.removeQueries({ queryKey: ['authUser'] })
  await queryClient.removeQueries({ queryKey: ['accessToken'] })
  useThemeStore.getState().reset()
}

export const hasPermission = async (
  permission: TPermissionKey
): Promise<boolean> => {
  const auth = await getAuth()

  return auth?.permissions?.includes(permission) ?? false
}

// Legacy re-export shim — new code should import from `@/core/lib/route-guards`.
export { routeHasPermission } from '@/core/lib/route-guards'
